import { types } from "mobx-state-tree";
import Team from "../Teams/Team";

const AgentTeam = types
  .model("AgentTeam", {
    team: types.reference(types.late(() => Team)),
    loggedIn: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    setStatus(status) {
      self.loggedIn = status;
    },
  }));

export default AgentTeam;
